import { ApiError, QueryKeys, Role } from '@connect-x-app/shared-domain-models';
import { getRoles } from '@connect-x-app/web-data-access';
import { useQuery } from '@tanstack/react-query';

export const useGetRoles = (options?: { enabled?: boolean }) =>
  useQuery<Role[], ApiError>({ enabled: options?.enabled ?? true, queryFn: getRoles, queryKey: [QueryKeys.ROLES] });
